<template>
	<div class="manage">
		<leftNav class='leftNavManage' :htmlon='htmlon' />
		<topBar class='topBar'  :htmlon='htmlon'/>
		<!-- <appMain class='appMain' /> -->
		<transition name="fade-transform" mode="out-in">
			<router-view class='appMain'/>
		</transition>
	</div>
</template>

<script>
	import leftNav from "./components/leftNav"
	import topBar from "./components/topBar"
	import appMain from "./components/topBar"
	export default{
		components:{
			leftNav,topBar,appMain
		},
		// watch:{
		// 	"$store.state.htmlon":{
		// 		handler(value){
		// 			this.htmlon='1'
		// 		},
		// 	}
		// },
		data(){
			return{
				htmlon:1
			}
		}
	}
</script>

<style lang="scss">
@import "../../styles/colors.scss";
.manage .leftNav{
	height: 100%;
	width: $left_manage_width;
	background: #273239;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 3;
}
.manage .leftNavManage{
	height: 100%;
	width: $left_manage_width;
	background: #273239;
	position: fixed;
	left: 0;
	top: 0;
	overflow: auto;
	z-index: 3;
}
.manage .logo{
	width: 100%;
	height: $top_height;
	background: #2e3c45;
	color: #fff;
	overflow: hidden;
	display: flex;
	justify-content: center;
	cursor: pointer;
}
.manage .logo:hover{
	opacity: 0.8;
}
.manage .logo img{
	height: 100%;
}
.manage .topBar{
	width: calc(100% - 190px);
	margin-left: $left_manage_width;
	height: $top_height;
	position: absolute;
	top: 0;
	left: 0;
	box-shadow: 0 1px 4px 0 rgba(0,0,0,0.15);
	z-index: 2;
	background: #fff;
}
.manage .appMain{
	z-index: 1;
	width: calc(100vw - 190px) ;
	min-height: calc(100vh - 70px);
	position: absolute;
	top: 0;
	left: 0;
	background: rgb(240, 240, 240);
	top: 70px;
	left: 190px;
}
</style>



// WEBPACK FOOTER //
// src/views/laout/laoutManage.vue